import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Alert,
  Platform,
  Modal,
} from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";
import { BlurView } from "expo-blur";
import BackgroundVideoBanner from "../components/BackgroundVideoBanner";
import { useLayoutEffect, useState } from "react";
import { fetchEvents } from "../constants/api/eventApi";
import AsyncStorage from "@react-native-async-storage/async-storage";
import { Ionicons } from "@expo/vector-icons";
import LoadingScreen from "./LoadingScreen";

export default function SettingScreen({ navigation }) {
  const [eventSettings, setEventSettings] = useState({
    IsPoll: "0",
    IsFaceRec: "0",
    loading: true,
  });
  const [loading, setLoading] = useState(true);
  const [showWebLogoutModal, setShowWebLogoutModal] = useState(false);

  const fetchEventSettings = async () => {
    try {
      setLoading(true);
      const eventId = await AsyncStorage.getItem("eventId");
      const resp = await fetchEvents(eventId);
      if (resp && resp.Status && resp.Data && resp.Data.event) {
        setEventSettings({
          IsPoll: resp.Data.event.IsPoll || "0",
          IsFaceRec: resp.Data.event.IsFaceRec || "0",
          loading: false,
        });
      } else {
        setEventSettings((prev) => ({ ...prev, loading: false }));
      }
    } catch (error) {
      console.error("Error fetching event settings:", error);
      setEventSettings((prev) => ({ ...prev, loading: false }));
    } finally {
      setLoading(false);
    }
  };

  useLayoutEffect(() => {
    fetchEventSettings();
  }, []);

  const handleSettingPress = (settingName) => {
    // Handle navigation or actions based on setting
    console.log(`Pressed ${settingName}`);
    // You can add navigation logic here

    if (settingName === "Polls") {
      navigation.navigate("PollPage");
    } else if (settingName === "Notifications") {
      navigation.navigate("NotificationPage");
    }
    else if(settingName === "Face_ID") {
      navigation.navigate("FaceIdPage");
    }
  };

  const performLogout = async () => {
    try {
      await AsyncStorage.multiRemove([
        "eventId",
        "userId",
        "eventName",
        "eventLogo",
        "mobBanner",
        "fileFieldNames"
      ]);
      
      navigation.navigate("EventRegister");
      console.log("User logged out");
    } catch (error) {
      console.error("Logout error:", error);
    }
  };

  const handleLogout = async () => {
    console.log("Platform:", Platform.OS); // Debug log
    if (Platform.OS === "web") {
      setShowWebLogoutModal(true); // Show custom modal
    } else {
      // Native Alert
      Alert.alert("Logout", "Are you sure you want to logout?", [
        { text: "Cancel", style: "cancel" },
        {
          text: "Logout",
          style: "destructive",
          onPress: async () => {
            await performLogout();
          },
        },
      ]);
    }
  };

  const SettingItem = ({ iconName, title, onPress, showChevron = true }) => (
    <TouchableOpacity style={styles.settingItem} onPress={onPress}>
      <View style={styles.settingLeft}>
        <View style={styles.iconContainer}>
          <Ionicons name={iconName} size={24} color="#FFFFFF" />
        </View>
        <Text style={styles.settingText}>{title}</Text>
      </View>
      {showChevron && (
        <Ionicons
          name="chevron-forward"
          size={20}
          color="#FFFFFF"
          opacity={0.7}
        />
      )}
    </TouchableOpacity>
  );

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <View style={styles.rootContainer}>
      <BackgroundVideoBanner />
      <SafeAreaView style={styles.wrapper}>
        <TouchableOpacity
          style={styles.fixedBackButton}
          onPress={() => navigation.navigate("Home")}
        >
          <Ionicons name="chevron-back" size={24} color="#FFFFFF" />
        </TouchableOpacity>

        <BlurView intensity={30} style={styles.container}>
          <View style={styles.header}>
            <Text style={styles.title}>Account Settings</Text>
          </View>

          <ScrollView
            style={styles.scrollContainer}
            contentContainerStyle={styles.scrollContent}
            showsVerticalScrollIndicator={false}
          >
            {/* Setting Items */}
           
            {!eventSettings.loading && eventSettings.IsPoll === "1" && (
              <SettingItem
                iconName="bar-chart-outline"
                title="Polls"
                onPress={() => handleSettingPress("Polls")}
              />
            )}
            <SettingItem
              iconName="notifications-outline"
              title="Notifications"
              onPress={() => handleSettingPress("Notifications")}
            />
            {!eventSettings.loading && eventSettings.IsFaceRec === "1" && (
              <SettingItem
                iconName="scan-outline"
                title="Face ID"
                onPress={() => handleSettingPress("Face_ID")}
              />
            )}
            <SettingItem
              iconName="log-out-outline"
              title="Log Out "
              onPress={handleLogout}
              showChevron={false}
            />
          </ScrollView>
        </BlurView>
      </SafeAreaView>

      {/* Custom Modal for Web Only */}
      {Platform.OS === "web" && (
        <Modal
          visible={showWebLogoutModal}
          transparent={true}
          animationType="fade"
          onRequestClose={() => setShowWebLogoutModal(false)}
        >
          <View style={styles.modalOverlay}>
            <View style={styles.modalBox}>
              <Text style={styles.modalTitle}>Logout</Text>
              <Text style={styles.modalText}>
                Are you sure you want to logout?
              </Text>
              <View style={styles.modalButtons}>
                <TouchableOpacity
                  style={[styles.modalButton, styles.cancelButton]}
                  onPress={() => setShowWebLogoutModal(false)}
                >
                  <Text style={styles.cancelButtonText}>Cancel</Text>
                </TouchableOpacity>
                <TouchableOpacity
                  style={[styles.modalButton, styles.logoutButton]}
                  onPress={async () => {
                    setShowWebLogoutModal(false);
                    await performLogout();
                  }}
                >
                  <Text style={styles.logoutButtonText}>Logout</Text>
                </TouchableOpacity>
              </View>
            </View>
          </View>
        </Modal>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  rootContainer: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  wrapper: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 16,
    width: "100%",
  },
  fixedBackButton: {
    position: "absolute",
    top: 40,
    left: 16,
    zIndex: 10,
    backgroundColor: "rgba(0,0,0,0.3)",
    padding: 8,
    borderRadius: 20,
  },
  container: {
    height: "90%",
    width: "100%",
    borderRadius: 20,
    backgroundColor: "rgba(255,255,255,0.2)",
    borderWidth: 1,
    borderColor: "rgba(255,255,255,0.5)",
    overflow: "hidden",
    marginTop:15
  },
  header: {
    flexDirection: "row",
    alignItems: "flex-start",
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 18,
  },
  backButton: {
    marginRight: 12,
    padding: 4,
    alignItems: "flex-end",
    justifyContent: "flex-start",
  },
  title: {
    fontSize: 22,
    fontWeight: "600",
    color: "#FFFFFF",
    flex: 1,
  },
  scrollContainer: {
    flex: 1,
  },
  scrollContent: {
    padding: 16,
    paddingTop: 8,
    flexGrow: 1,
    gap: 6,
  },
  settingItem: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingVertical: 16,
    paddingHorizontal: 16,
    marginBottom: 1,
    backgroundColor: "rgba(255,255,255,0.1)",
    borderWidth: 1,
    borderColor: "white",
    borderRadius: 12,
    marginVertical: 4,
  },
  settingLeft: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
  },
  iconContainer: {
    width: 40,
    height: 40,
    borderRadius: 20,
    borderColor: "white",
    borderWidth: 2,
    backgroundColor: "rgba(255,255,255,0.2)",
    alignItems: "center",
    justifyContent: "center",
    marginRight: 12,
  },
  settingText: {
    fontSize: 16,
    fontWeight: "500",
    color: "#FFFFFF",
    flex: 1,
  },
  modalOverlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.7)",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  modalBox: {
    width: "90%",
    maxWidth: 400,
    backgroundColor: "white",
    padding: 20,
    borderRadius: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 4 },
    shadowOpacity: 0.3,
    shadowRadius: 8,
    elevation: 10,
    ...(Platform.OS === "web" && {
      boxShadow: "0 4px 20px rgba(0,0,0,0.3)",
    }),
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: "bold",
    marginBottom: 10,
    textAlign: "center",
    color: "#333",
  },
  modalText: {
    marginBottom: 20,
    textAlign: "center",
    color: "#666",
    fontSize: 16,
  },
  modalButtons: {
    flexDirection: "row",
    justifyContent: "space-around",
    paddingTop: 10,
  },
  modalButton: {
    paddingVertical: 12,
    paddingHorizontal: 24,
    borderRadius: 8,
    minWidth: 80,
    alignItems: "center",
  },
  cancelButton: {
    backgroundColor: "#f8f9fa",
    borderWidth: 1,
    borderColor: "#007BFF",
  },
  logoutButton: {
    backgroundColor: "#dc3545",
  },
  cancelButtonText: {
    color: "#007BFF",
    fontWeight: "bold",
    fontSize: 16,
  },
  logoutButtonText: {
    color: "white",
    fontWeight: "bold",
    fontSize: 16,
  },
});
